// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let QuickTableCell = function ()
{
    // Cell data    
    this.value = null;
    this.formattedValue = "";

    this.groupByValue = "";     // The context menu action "Group by" is processed using this value, e.g., #114165.

    // Colors
    this.BackColor = null;
    this.ForeColor = null;

    this.BackColorRecover = null;
    this.ForeColorRecover = null;
    this.isDirty = true;
    /// Произошла раскраска ячейки - через определленое время нужно сбросить цвет
    this.ColoringOccured = -1;

    this.textPattern = null;

    this.CustomDrawingHandler = null;
    this.CustomDrawingHandlerParameters = null;

    this.TooltipKey = '';

    this.TruncateTextOverflowAddingEllipsis = false; // нужно ли обрезать не влезающий в ячейку текст добавляя троеточие
};